/* eslint-disable */
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle) {
        this.addEventListener('touchstart', handle, { passive: !ns.includes('noPreventDefault') });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle) {
        this.addEventListener('touchmove', handle, { passive: !ns.includes('noPreventDefault') });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle) {
        this.addEventListener('wheel', handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle) {
        this.addEventListener('mousewheel', handle, { passive: true });
    }
};
/* eslint-enable */

(
    function ($) {
        'use strict';

        var Site = {
            $body: $('html'),
            $searchContainer: $('.header__search'),

            $btnToTop: $('.btn--to-top'),
            $lightCase: $('a[data-rel^=lightcase]'),
            $lightCaseApim: $('a.apim'),
            $socialShare: $('.social-share'),
            $orderPickupEnabled: false,

            $overlay: $('.loading'),

            $slider: $('.is-slider'),
            $sliderUbr: $('.slider-ubr'),
            $sliderProducts: $('.is-slider-products'),
            $sliderArticles: $('.is-slider-articles'),
            $sliderProductGallery: $('.is-slider-product-gallery'),
            $sliderProductGalleryThumbs: $('.product-thumbs .owl-carousel'),

            sliderProductSyncedSecondary: false,

            $responsiveTables: $('table:not(.not-responsive):not(.compare-table)'),
            $responsiveEmbedVideos: $('iframe[src*="youtube"], iframe[src*="vimeo"]'),

            $filter: $('.product-filter'),

            onHandleFilterChange: function () {
                var newUrl = new URL(window.location.href);
                newUrl.searchParams.delete('filter[]');

                this.$filter.filter(':checked').map(function () {
                    newUrl.searchParams.append('filter[]', this.name + '==' + this.value);
                }).get();

                $.ajax({
                    url: newUrl.href,
                    method: 'GET',
                    success: function(response) {
                        var $html = $(response);
                        var $results = $html.find('[data-product-list]');
                        $('[data-product-list]').html($results.html());
                        window.history.pushState({}, '', newUrl.href);
                    }
                });
            },

            resetFilters: function () {
                this.$filter.prop('checked', false);

                var self = this;
                $.ajax({
                    url: window.location.href.split('?')[0], // or your base filter URL
                    method: 'GET',
                    success: function(response) {
                        var $html = $(response);
                        var $results = $html.find('[data-product-list]');
                        $('[data-product-list]').html($results.html());
                        // Uncheck filters again in the new DOM
                        self.$filter.prop('checked', false);
                        window.history.pushState({}, '', window.location.href.split('?')[0]);
                    }
                });
            },

            /**
             * Toggle overlay in checkout process.
             */
            toggleOverlay: function () {
                if ($('[name="accept_terms"]').length > 0 && $('[name="accept_terms"]').prop('checked') !== true) {
                    return true;
                }

                this.$overlay.show();
                return true;
            },

            /**
             * Display cart modal message.
             *
             * @param success
             * @param message
             */
            displayCartModal: function (success, message) {
                var $element = $('#ajax-product-to-cart-modal');
                var $title   = $element.find('[data-title]');
                var $message = $element.find('[data-message]');

                $message.html('');
                if (success) {
                    $title.text($title.attr('data-title-success'));
                } else {
                    $title.text($title.attr('data-title-error'));
                }

                if (message.length > 0) {
                    $message.html(message);
                }

                $element.modal('show');
            },

             /**
             * Display cart modal message.
             *
             * @param success
             * @param message
             */
             displayArticleModal: function (element) {
                var $clickElement = $(element.currentTarget);
                var $element = $('#ajax-article-modal');
                var $message = $element.find('[data-message]');
                var $articleOldURL = window.location.href;
                
                $.ajax({
                    url: $clickElement.data('href'),
                    dataType: 'html',
                    success: function (data) {
                        var $html = $(data)[3];
                        $message.html($html);
                        $element.modal('show');
                        $message.scrollTop(0);

                        let url = $clickElement.data('href').split('?')[0];
                        history.pushState(null, null, url);

                        $element.on('hidden.bs.modal', function () {
                            history.pushState(null, null, $articleOldURL);
                        });
                    }
                });
            },

            /**
             * Handle adding a product to the cart.
             *
             * @param element
             */
            onAddProductToCart: function (element) {
                var $element = $(element.currentTarget);
                var href = $element.attr('action');

                $(document.body).css({ cursor: 'wait' });

                $.ajax({
                    url: href,
                    data: $element.serialize(),
                    dataType: 'json',
                    success: $.proxy(function (result) {
                        if (result.success && result.redirect) {
                            window.location = result.redirect;
                        }

                        this.setRelatedHtml($element.serialize());

                        if (result.message && result.message.length) {
                            this.displayCartModal(result.success, result.message);
                        }

                        $(document.body).css({ cursor : 'default' });

                        this.updateCartCount();
                        this.updateHeaderCart();
                    }, this)
                });

                return false;
            },

            /**
             * Fetch related products and show in modal.
             *
             * @param {*} post
             * @returns
             */
            setRelatedHtml: function (post) {
                var $element = $('#ajax-product-to-cart-modal');
                var $related = $element.find('[data-related]');

                $.ajax({
                    type: 'POST',
                    url: '/assets/components/site/connector.php',
                    data: {
                        action: 'web/cart/related',
                        form:  post
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.message && data.message.length) {
                            $related.html(data.message);
                        }
                    }
                });
            },

            /**
             * Focus search form.
             */
            onClickSearchPlaceholder: function () {
                $('input', this.$searchContainer).focus();
            },

            /**
             * Toggle the search form in the header.
             */
            onToggleSearchForm: function () {
                this.$searchContainer.stop().slideToggle();

                if ($('input', this.$searchContainer).length > 0) {
                    $('input', this.$searchContainer).focus();
                }

                return false;
            },

            /**
             * Check the search form for an empty value.
             *
             * @param element
             */
            onSubmitSearchForm: function (element) {
                var $input = $('input', $(element.currentTarget));

                if ($input.val() === '' || $input.val() === $input.attr('placeholder')) {
                    /* eslint-disable */
                    alert($(element.currentTarget).attr('data-alert'));
                    /* eslint-enable */

                    return false;
                }

                return true;
            },

            /**
             * Viewport check
             *
             * @param element
             * @param nearViewport
             */
            inViewport: function (element, nearViewport) {
                var $window = $(window);
                var $element = $(element);
                var position = $window.scrollTop();
                var visible = position + $window.height();

                if (nearViewport) {
                    return visible - 50 >= $element.offset().top;
                }

                return (visible >= ($element.offset().top + $element.outerHeight())
                        && position <= ($element.offset().top + $element.outerHeight()));
            },

            /**
             * Detect window scroll to make navigations sticky.
             */
            detectWindowScroll: function () {
                var $body = $('body');

                $(window).scroll(function () {
                    var windowScrollTop = $(this).scrollTop();
                    if (windowScrollTop > 0) {
                        $body.addClass('sticky-header');
                    } else {
                        $body.removeClass('sticky-header');
                    }
                }).trigger('scroll');
            },

            /**
             * Detect window scroll to animate blocks.
             */
            detectWindowScrollAnimationBlocks: function () {
                $(window).scroll(function () {
                    $('[data-animate-on-scroll]').each(function (i, element) {
                        var $element = $(element);

                        if (!$element.hasClass('is-visible')) {
                            if (Site.inViewport($element, true)) {
                                $element.addClass('is-visible');
                            }
                        }
                    });
                }).trigger('scroll');
            },

            /**
             * Toggle the main navigation.
             */
            onToggleNavigation: function () {
                $('.nav-toggle').toggleClass('active');
                this.$body.toggleClass('primary-navigation-active');

                return false;
            },

            /**
             * Toggle sub navigation in the main navigation.
             *
             * @param element
             */
            onToggleSubNavigation: function (element) {
                var $target = $(element.currentTarget);

                if ((parseInt($target.parent('li').attr('data-level'), 10) === 1 || window.innerWidth < 992) && $target.parent('li').hasClass('subnav-onclick')) {
                    $('.close-subnav').removeClass('active');
                    $target.parent('li').siblings('li').removeClass('subnav-active');
                    $target.parent('li').toggleClass('subnav-active');
                    $target.parent('li').parent('ul').toggleClass('slide-left');
                    $target.parent('li').find('> .subnavigation > .wrapper > .close-subnav').addClass('active');
                    $target.find('> ul').stop().slideToggle();
            
                    return false;
                }
            
                return true;
            },

            /**
             * Close the dropdown navigation
             * @param element
             */
            onCloseNavigation: function (element) {
                var $target = $(element.currentTarget);

                $target.closest('li.subnav-active').removeClass('subnav-active');
            },

            /**
             * Close the dropdown subnavigation
             * @param element
             */
            onCloseSubNavigation: function (element) {
                var $target = $(element.currentTarget);

                $('.close-subnav').each(function (index, item) {
                    $(item).addClass('active');
                });
                $target.closest('li.subnav-active').removeClass('subnav-active');
                $target.closest('ul.slide-left').removeClass('slide-left');
            },

            /**
             * Toggle scroll to top button.
             */
            onToggleScrollToTop: function () {
                if (window.scrollY > $(window).height()) {
                    this.$btnToTop.fadeIn();
                } else {
                    this.$btnToTop.fadeOut();
                }
            },

            /**
             * Scroll to the top of the page.
             */
            onClickScrollToTop: function () {
                $('html,body').animate({
                    scrollTop: 0
                });

                return false;
            },

            /**
             * Click hash.
             *
             * @param element
             */
            onClickHash: function (element) {
                var $element = $(element.currentTarget.hash);
                element.preventDefault();

                if ($element.length) {
                    $('html, body').animate({
                        scrollTop: $element.offset().top - 158
                    }, 500);
                }
            },

            /**
             * Toggle social share.
             *
             * @param element.
             */
            onToggleSocialShare: function (element) {
                $(element.currentTarget).parents('.social-share').toggleClass('active');

                return false;
            },

            /**
             * Copy share URL to clipboard.
             *
             * @param element.
             */
            onCopyToClipboard: function (element) {
                var copy = false;
                var $element = $(element.currentTarget);

                $element.select();

                try {
                    copy = document.execCommand('copy');
                } catch (err) {
                    copy = false;
                }

                if (copy) {
                    $element.addClass('active').val($element.attr('data-success'));
                } else {
                    $element.removeClass('active');
                }
            },

            /**
             * Init datepickers
             */
            initDatePickers: function () {
                $('#rental_begin').datepicker({
                    changeMonth: true,
                    minDate: '+1d'
                }).on('change', function () {
                    var startDate = $(this).datepicker('getDate');
                    $('#rental_end').datepicker('option', 'minDate', startDate);
                });
                $('#rental_end').datepicker({
                    changeMonth: true,
                    minDate: '+1d',
                    maxDate: '+1000d'
                }).on('change', function () {
                    var endDate = $(this).datepicker('getDate');
                    $('#rental_begin').datepicker('option', 'maxDate', endDate);
                });
            },

            /**
             * Init lightcase.
             */
            initLightCase: function () {
                this.$lightCase.lightcase({
                    showSequenceInfo: false,
                    swipe: true,
                    fullscreenModeForMobile: true,
                    showTitle: false
                });
            },

            /**
             * Init lightcase additional product info.
             */
            initLightCaseApim: function () {
                if ($('#additional-product-info-modal').length) {
                    this.$lightCaseApim.lightcase({
                        showSequenceInfo: false,
                        swipe: true,
                        fullscreenModeForMobile: true,
                        showTitle: false,
                        href: '#additional-product-info-modal'
                    });
                }
            },

            /**
             * Init the default slider.
             */
            initSlider: function () {
                this.$slider.owlCarousel({
                    lazyLoad:true,
                    items: 1,
                    animateOut: 'fadeOut',
                    autoplay: true,
                    autoplayTimeout: 3500,
                    autoplayHoverPause: true,
                    loop: true,
                    nav: false,
                    dots: true,
                    responsive: {
                        0: {
                            dots: false
                        },
                        992: {
                            dots: true
                        }
                    }
                });
            },

            /**
             * Init the product gallery slider.
             */
            initSliderProductDetail: function () {
                this.sliderProductSyncedSecondary = true;

                this.$sliderProductGallery
                    .owlCarousel({
                        lazyLoad:true,
                        items: 1,
                        animateOut: 'fadeOut',
                        autoplay: false,
                        loop: false,
                        nav: true,
                        dots: true
                    })
                    .on('changed.owl.carousel', this.onChangeSliderProductGalleryPosition);

                this.$sliderProductGalleryThumbs
                    .on('changed.owl.carousel', this.onChangeSliderProductGalleryThumbsPosition)
                    .on('initialized.owl.carousel', this.onInitializeSliderProductGalleryThumbsPosition)
                    .owlCarousel({
                        lazyLoad:true,
                        items: 4,
                        autoplay: false,
                        autoWidth: false,
                        loop: false,
                        nav: true,
                        dots: false,
                        mouseDrag: false
                    });
            },

            /**
             * Init the UBR slider.
             */
            initSliderUbr: function () {
                if (window.innerWidth < 992) {
                    this.$sliderUbr.owlCarousel({
                        lazyLoad:true,
                        items: 1,
                        animateOut: 'fadeOut',
                        autoplay: true,
                        autoplayTimeout: 3500,
                        autoplayHoverPause: true,
                        loop: true,
                        nav: false,
                        dots: false
                    });
                } else {
                    this.$sliderUbr.owlCarousel('destroy');
                }
            },


            /**
             * Change product gallery slider.
             *
             * @param element
             */
            onChangeSliderProductGalleryPosition: function (element) {
                var active = 0;
                var start = 0;
                var end = 0;
                var current = element.item.index;
                var count = element.item.count - 1;

                /**
                 * to enable loop, uncomment this block
                 *
                 * var current = Math.round(el.item.index - el.item.count / 2 - 0.5);
                 */

                if (current < 0) {
                    current = count;
                } else if (current > count) {
                    current = 0;
                }

                active = Site.$sliderProductGalleryThumbs.find('.owl-item.active').length - 1;
                start = Site.$sliderProductGalleryThumbs.find('.owl-item.active').first().index();
                end = Site.$sliderProductGalleryThumbs.find('.owl-item.active').last().index();

                Site.$sliderProductGalleryThumbs.find('.owl-item').removeClass('current').eq(current).addClass('current');

                if (current > end) {
                    Site.$sliderProductGalleryThumbs.data('owl.carousel').to(current, 100, true);
                } else if (current < start) {
                    Site.$sliderProductGalleryThumbs.data('owl.carousel').to(current - active, 100, true);
                }
            },

            /**
             * Change product gallery slider.
             *
             * @param element
             */
            onChangeSliderProductGalleryThumbsPosition: function (element) {
                if (this.sliderProductSyncedSecondary) {
                    this.$sliderProductGalleryThumbs.data('owl.carousel').to(element.item.index, 100, true);
                }
            },

            /**
             * Initialize product gallery slider.
             *
             * @param element
             */
            onInitializeSliderProductGalleryThumbsPosition: function (element) {
                $(element.currentTarget).find('.owl-item').bind('click', function (item) {
                    Site.$sliderProductGallery.data('owl.carousel').to($(item.currentTarget).index(), 300, true);

                    item.preventDefault();
                }).eq(0)
                    .addClass('current');
            },

            /**
             * Init the product slider.
             */
            initSliderProducts: function () {
                this.$sliderProducts.owlCarousel({
                    lazyLoad:true,
                    items: 5,
                    autoplay: false,
                    autoplayTimeout: 3500,
                    autoplayHoverPause: false,
                    loop: false,
                    nav: false,
                    dots: false,
                    responsive: {
                        0: {
                            items: 1,
                            stagePadding: 40
                        },
                        768: {
                            items: 2,
                            stagePadding: 40
                        },
                        990: {
                            items: 5
                        }
                    }
                });
            },

            /**
             * Init the product slider.
             */
            initSliderArticles: function () {
                this.$sliderArticles.owlCarousel({
                    lazyLoad:true,
                    items: 4,
                    autoplay: false,
                    autoplayTimeout: 3500,
                    autoplayHoverPause: false,
                    loop: false,
                    nav: true,
                    dots: false,
                    mouseDrag: false,
                    responsive: {
                        0: {
                            items: 1,
                            spaceBetween: 15
                        },
                        768: {
                            items: 3,
                            margin: 15
                        },
                        990: {
                            items: 4,
                            margin: 15
                        }
                    }
                });
            },

            /**
             * Init the responsive tables.
             */
            initResponsiveTables: function () {
                this.$responsiveTables.each(function (i, element) {
                    $(element).wrap('<div class="table-wrapper" />');
                });
            },

            lazyLoadIframes: function () {
                const iframes = document.querySelectorAll('iframe[data-src]');

                // Loop through each iframe and set the src attribute dynamically
                iframes.forEach(iframe => {
                    const dataSrc = iframe.getAttribute('data-src'); // Get the data-src attribute
                    if (dataSrc) {
                        iframe.src = dataSrc; // Set the src attribute
                    }
                });
            },

            /**
             * Init the responsive embed videos.
             */
            initResponsiveEmbedVideos: function () {
                this.$responsiveEmbedVideos.each(function (i, element) {
                    var $element = $(element);
                    var ratio = $element.attr('ratio');

                    $element.wrap('<div class="video-wrapper" />').wrap('<div class="video-wrapper__inner" />');

                    if (ratio === '4:3') {
                        $('<img src="/assets/img/video-spacer-4x3.png" class="img-fluid" />').insertBefore($element);
                    } else {
                        $('<img src="/assets/img/video-spacer-16x9.png" class="img-fluid" />').insertBefore($element);
                    }
                });
            },

            /**
             * Mail share popup.
             */
            initMailSharePopup: function () {
                var hash = window.location.hash.substring(1);

                if (this.$socialShare.length > 0) {
                    if (hash === 'mail-popup') {
                        if ($('.has-error', '#mail-popup').length !== 0) {
                            $('#gtm-share-email').trigger('click');
                        }
                    }
                }
            },

            /**
             * Toggle blocks.
             */
            initToggleBlocks: function () {
                $('[data-toggle]').each(function () {
                    var $button = $('<button class="toggle-block__title" />').on('click', function () {
                        $(this).parents('[data-toggle]').toggleClass('active');

                        return false;
                    });

                    $(this).children('[data-toggle-title]').wrap($button);
                });

                $('[data-toggle-content]').each(function () {
                    var $element = $(this);
                    var $openTitle = $(this).attr('data-toggle-content-open');
                    var $closeTitle = $(this).attr('data-toggle-content-close');
                    var $button = $('<button class="toggle-block-content__link" title="' + $openTitle + '" />').html($openTitle).on('click', function () {
                        if ($element.hasClass('active')) {
                            $(this).attr('title', $openTitle).html($openTitle);
                        } else {
                            $(this).attr('title', $closeTitle).html($closeTitle);
                        }

                        $element.toggleClass('active');

                        return false;
                    });

                    $('> *', $element).wrapAll('<div class="toggle-block-content__content" />');

                    $element.append($button);
                });
            },

            listSearchSuggestions: function (element) {
                var value = $(element.currentTarget).val();
                var suggestElement = $('[data-search-suggestions]');
                var context = this.$searchContainer.data('context');

                if (value.length < 1) {
                    suggestElement.hide();
                    return;
                }

                $.ajax({
                    url: '/assets/components/simplesearch/connector.php?action=web/autosuggestions&search=' + value + '&context=' + context,
                    dataType: 'JSON',
                    complete: function (result) {
                        var suggestions = [];
                        if (result.responseJSON.results.length) {
                            $(result.responseJSON.results).each(function (idx, suggestion) {
                                suggestions.push($('<li>', {
                                    html: '<a href="' + suggestion.url + '" class="simplesearch-suggestions--item" title="' + suggestion.value + '">' + suggestion.value + '<a/>',
                                    'data-suggestion': suggestion.value
                                }));
                            });
                        }

                        if (suggestions.length > 0) {
                            suggestElement.html(suggestions).show();
                        } else {
                            suggestElement.html(suggestions).hide();
                        }
                    }
                });
            },

            handleSearchSuggestClick: function (element) {
                var suggestionElement = $(element.currentTarget);

                $(suggestionElement).parents('form').find('input[type="text"]').val($(suggestionElement).attr('data-suggestion'));
                $(suggestionElement).parents('form').submit();
            },

            /**
             * Open header contact form
             *
             * @param element
             */
            openToggleContact: function () {
                $('html, body').animate({
                    scrollTop: $('.footer__contact__wrapper').offset().top
                }, 1000);

                return false;
            },

            /**
             * Open header contact form
             *
             * @param element
             */
            openToggleContactForm: function () {
                $('.header__contact').toggleClass('form-active');
                $('.header__contact__wrapper').toggleClass('active');

                return false;
            },

            /**
             * Toggle searchbox
             *
             * @param element
             */
            triggerSearchBox: function (element) {
                var $element = $(element.currentTarget);

                element.preventDefault();
                $element.parent().toggleClass('active');

                if ($element.parent().hasClass('active')) {
                    setTimeout(function () {
                        $element.parent().find('input').focus();
                    }, 200);
                }
            },

            /**
             * Toggle tooltip
             *
             * @param element
             */
            toggleTooltip: function (element) {
                var $element = $(element.currentTarget);
                element.preventDefault();

                $element.toggleClass('active');
            },

            initMSearch2: function () {
                var uri = window.location.hash.replace('#', '?');
                if ($('#mse2_mfilter').length) {
                    if (window.location.hash !== '' && mSearch2.Hash.oldbrowser()) {
                        window.location.href = document.location.pathname + uri;
                    } else {
                        mSearch2.initialize('body');
                    }
                }
            },

            /**
             * Either show/hide state field (provinces) based on selected country.
             * This event is triggered on document ready and when country select is changed.
             *
             * @param element
             */
            displayStates: function (element) {
                var self = this;

                if (typeof element !== 'undefined') {
                    self.displayState($(element.currentTarget));
                } else {
                    $('[data-toggle-state]').each(function (idx, select) {
                        self.displayState(select);
                    });
                }
            },

            /**
             * Either show/hide next (state) field based on country select value.
             *
             * @param select
             */
            displayState: function (select) {
                if ($(select).val() === 'NL') {
                    $(select).parents('.form-group').next().show();
                } else {
                    $(select).parents('.form-group').next().hide();
                }
            },

            /**
             * Set hidden input request_offer to 1 in webshop checkout.
             * This will trigger the request offer checkout flow.
             */
            checkoutRequestOffer: function () {
                $('input[name="request_offer"]').val(1);
            },

            initPostcodeApi: function () {
                $('[data-postcode-api]').PostcodeApi();
            },

            /**
             * Handle product variation select.
             *
             * @param element
             */
            handleProductVariantSelect: function (element) {
                window.location = $(element.currentTarget).val();
            },

            /**
             * Toggle read more links for product specs and product description.
             *
             * @param element
             */
            toggleReadmoreLinks: function (element) {
                var $element = $(element.currentTarget);

                element.preventDefault();

                $element.parent().toggleClass('active');
                if ($element.parent().hasClass('active')) {
                    $element.html($element.attr('data-close'));
                } else {
                    $element.html($element.attr('data-open'));
                }
            },

            /**
             * Toggle the chat text.
             *
             * @param element
             */
            onToggleChat: function (element) {
                var $element = $(element.currentTarget);
                var collapsedTitle = $element.attr('data-chat-collapsed');
                var expandedTitle = $element.attr('data-chat-expanded');

                if ($element.hasClass('active')) {
                    $element.attr('title', collapsedTitle).removeClass('active').find('span').html(collapsedTitle);
                } else {
                    $element.attr('title', expandedTitle).addClass('active').find('span').html(expandedTitle);
                }

                return false;
            },

            /**
             * Update cart counter.
             */
            updateCartCount: function () {
                $.ajax({
                    type: 'POST',
                    url: '/assets/components/site/connector.php',
                    data: {
                        action: 'web/cart/count'
                    },
                    dataType: 'html',
                    success: function (amount) {
                        var counter = $('[data-cart-count]');

                        /* If changed, then fade out and fade in. */
                        if ($(counter).text() !== amount) {
                            $(counter).fadeOut('fast', function () {
                                $(counter).html(amount);
                            });

                            $(counter).fadeIn();
                        }
                    }
                });
            },

            /**
             * Update the header cart.
             */
            updateHeaderCart: function () {
                $.ajax({
                    type: 'POST',
                    url: '/assets/components/site/connector.php',
                    data: {
                        action: 'web/cart/products'
                    },
                    dataType: 'html',
                    success: function (html) {
                        var cart = $('.shopping-cart__layover .cart-list');

                        cart.replaceWith(html);
                    }
                });
            },

            /**
             * Toggle the order details accordion.
             *
             * @param element
             */
            onToggleOrderDetails: function (element) {
                if (!$(element.currentTarget).closest('.account-order__details').length) {
                    this.toggleOrderDetailsButtonText($(element.currentTarget).parents('.account-order-overview__item').find('[data-orders-view-btn]'));

                    $(element.currentTarget).parent().parent().toggleClass('active');
                }
            },

            toggleOrderDetailsButtonText: function ($element) {
                if ($element.text() === $element.attr('data-view-text')) {
                    $element.text($element.attr('data-reorder-text'));
                } else {
                    $element.text($element.attr('data-view-text'));
                }
            },

            /**
             * If text equals to data-view-text, then preventDefault and change text.
             * If not data view text, then do not do anything.
             */
            onToggleOrderDetailsButton: function (element) {
                var $element = $(element.currentTarget);

                if ($element.text() === $element.attr('data-view-text')) {
                    element.preventDefault();

                    /* Trigger toggle details. */
                    $element.parents('.account-order-overview__item').toggleClass('active');

                    this.toggleOrderDetailsButtonText($element);
                }
            },

            /**
             * Toggle the extended adress fields based on selected address type.
             * @param element
             */
            onChangeAddressType: function (element) {
                if (parseInt($(element.currentTarget).val(), 10) === 1) {
                    $('[data-extended-address-fields]').hide();
                } else {
                    $('[data-extended-address-fields]').show();
                }
            },

            /**
            * Toggle the Shipping & Pick up summary.
            * @param element
            */
            onChangeShippingType: function (element) {
                if (parseInt($(element.currentTarget).val(), 10) === 2
                    || parseInt($(element.currentTarget).val(), 10) === 5) {
                    $('.c-shipping.default').hide();
                    $('.c-shipping.pickup').show();
                } else {
                    $('.c-shipping.default').show();
                    $('.c-shipping.pickup').hide();
                }

                // Update the checkout summary when selecting shipping type
                var $shippingForm = $('[data-checkout-shipping-form]');
                $shippingForm.find('button[type="submit"]').attr('disabled', true);

                $('.c-cart-summary').addClass('cart-loading');

                $.ajax({
                    type: 'POST',
                    url: $shippingForm.attr('action'),
                    data: $shippingForm.serialize(),
                    success: function (response) {
                        if (response.output) {
                            var output = $(response.output);
                            var summary = $(output).filter('.c-checkout-summary');
                            if (summary) {
                                $('.c-checkout-summary').replaceWith(summary.get(0).outerHTML);
                            }
                        }

                        $shippingForm.find('button[type="submit"]').attr('disabled', false);
                    }
                });
            },

            updateSelectedAddressPreview: function (type, selectedAddress) {
                var fields = [
                    'city',
                    'zip',
                    'street',
                    'housenumber',
                    'country',
                    'country_formatted',
                    'state',
                    'firstname',
                    'lastname',
                    'email',
                    'phone',
                    'company'
                ];

                $(fields).each(function () {
                    $('[data-selected-address-' + type + '] [data-' + this + ']').text(selectedAddress[this]);
                });

                $('[data-selected-address-' + type + '] .line').each(function () {
                    var show = false;

                    $(this).find('span').each(function (idx, element) {
                        if ($(element).text().length > 0) {
                            show = true;
                        }
                    });

                    if (show) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });
            },

            /**
             * Add product to compare list
             *
             * @param element
             */
            addCompareProduct: function (element) {
                var value = $(element.currentTarget).data('compare'),
                    messageBlock = '';

                if (value > 0) {
                    $.ajax({
                        type: 'POST',
                        url: '/assets/components/site/connector.php',
                        data: {
                            action: 'web/compare/products',
                            id: value
                        },
                        dataType: 'json',
                        success: function (data) {
                            messageBlock = '<div class="notice ' + data.messageType + '"><p> ' + data.message + ' </p></div>';

                            $('[data-notice-block]').prepend(messageBlock);

                            Site.toggleCompareButton();
                        }
                    });
                }

                return false;
            },

            /**
             * Remove product to compare list
             *
             * @param element
             */
            removeCompareProduct: function (element) {
                var value = $(element.currentTarget).data('compare-product-remove');
                if (value > 0) {
                    $.ajax({
                        type: 'POST',
                        url: '/assets/components/site/connector.php',
                        data: {
                            action: 'web/compare/remove',
                            id: value
                        },
                        dataType: 'json',
                        success: function () {
                            window.location = window.location.pathname;
                            Site.toggleCompareButton();
                        }
                    });
                }

                return false;
            },

            /**
             * Toggle compare button
             */
            toggleCompareButton: function () {
                var context = $('.header [data-compare-overview]').data('compare-overview');

                $.ajax({
                    type: 'POST',
                    url: '/assets/components/site/connector.php',
                    data: {
                        action: 'web/compare/button',
                        context: context
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data >= 1) {
                            $('.header [data-compare-overview]').addClass('active');
                            $('.header [data-compare-count]').text(data);
                        } else {
                            $('.header [data-compare-overview]').removeClass('active');
                        }
                    }
                });
            },

            /**
             * When the existing address dropdown selection has changed.
             * @param event
             * @returns {boolean}
             */
            onChangeCheckoutSelectExistingAddress: function (event) {
                var value           = $(event.currentTarget).val();
                var type            = $(event.currentTarget).attr('data-type');
                var addressesArray  = JSON.parse($(event.currentTarget).parent('[data-' + type + '-addresses]').attr('data-' + type + '-addresses'));
                var selectedAddress = addressesArray[value];
                var fields = [
                    'city',
                    'zip',
                    'street',
                    'housenumber',
                    'country',
                    'country_formatted',
                    'state'
                ];

                if (value === '') {
                    $('[data-selected-address-' + type + ']').hide();

                    if (this === 'country_formatted') {
                        return true;
                    }

                    $(fields).each(function () {
                        if (this === 'street' || this === 'housenumber') {
                            $('[name="address[' + type + '][properties][' + this + ']"]').val('').parents('.form-group').show();
                        } else {
                            $('[name="address[' + type + '][' + this + ']"]').val('').parents('.form-group').show();
                        }
                    });

                    $(event.currentTarget).parents('.c-method-details').find('[data-checkout-existing-address-details]').parents('.form-group')
                        .hide();

                    this.updateCheckoutPersonalDetailFields(type, true);
                } else {
                    $(fields).each(function () {
                        if (this !== 'country_formatted') {
                            if (this === 'street' || this === 'housenumber') {
                                $('[name="address[' + type + '][properties][' + this + ']"]').val(selectedAddress[this]).parents('.form-group')
                                    .hide();
                            } else {
                                $('[name="address[' + type + '][' + this + ']"]').val(selectedAddress[this]).parents('.form-group')
                                    .hide();
                            }
                        }
                    });

                    $('[data-selected-address-' + type + ']').show();
                    $(event.currentTarget).parents('.c-method-details').find('[data-checkout-existing-address-details]').parents('.form-group')
                        .show();

                    if ($('[data-checkout-existing-address-details][data-type="' + type + '"]').prop('checked')) {
                        this.updateCheckoutPersonalDetailFields(type, false);
                    }

                    this.updateSelectedAddressPreview(type, selectedAddress);
                }

                return true;
            },

            updateCheckoutPersonalDetailFields: function (type, reset) {
                var selectedAddressID = $('[data-checkout-existing-address][data-type="' + type + '"]').val();
                var addressesArray    = JSON.parse($('[data-' + type + '-addresses]').attr('data-' + type + '-addresses'));
                var selectedAddress   = addressesArray[selectedAddressID];
                var fields = [
                    'firstname',
                    'lastname',
                    'email',
                    'phone',
                    'company',
                    'vat_registration'
                ];

                $(fields).each(function () {
                    var value = '';

                    if (!reset) {
                        value = selectedAddress[this];
                    }

                    if (this === 'vat_registration') {
                        $('[name="address[' + type + '][properties][' + this + ']"]').val(value);
                    } else {
                        $('[name="address[' + type + '][' + this + ']"]').val(value);
                    }
                });
            },

            /**
             * When checkbox use address details has been either checked/unchecked.
             * @param event
             */
            onChangeCheckoutUseAddressDetailsCheckbox: function (event) {
                var type    = $(event.currentTarget).attr('data-type');
                var checked = $(event.currentTarget).prop('checked');
                var reset   = !checked;

                this.updateCheckoutPersonalDetailFields(type, reset);
            },

            /*
             * Change VATNumber to uppercase.
             */
            keyUpVatRegistration: function (element) {
                var value = $(element.currentTarget).val();
                $(element.currentTarget).val(value.toUpperCase().replace(/[ .]/g, ''));
            },

            /*
             * Accept only numbers in phonenumber.
             */
            keyUpPhoneNumber: function (element) {
                var value = $(element.currentTarget).val();
                $(element.currentTarget).val(value.replace(/[^0-9+-]/g, ''));
            },

            toggleExtraOptions: function (element) {
                var option = $(element.currentTarget).data('filler');
                var value = $(element.currentTarget).val();

                if ($(element.currentTarget).is(':checked')) {
                    $('input[name="' + option + '"]').val(value);
                } else {
                    $('input[name="' + option + '"]').val('');
                }
            },

            onChangeCartItemQuantity: function (event) {
                const $quantityInput = $(event.currentTarget);

                const quantities = document.querySelectorAll('.c-cart-item-quantity-input');
                let minQuantity = Infinity;
                let totalQuantity = 0;

                quantities.forEach(input => {
                    const quantity = parseInt(input.value);
                    const min = parseInt(input.dataset.min);
                    if (min < minQuantity) {
                        minQuantity = min;
                    }
                    totalQuantity += quantity;
                });

                if (totalQuantity < minQuantity) {
                    $(event.currentTarget).val($(event.currentTarget).data('min'));
                }

                $(event.currentTarget).parents('.c-cart-wrapper').addClass('cart-loading');
                this.onChangeCartSubmit(event);
            },

            onChangeCartSubmit: function (element) {
                var $form = $('form.c-cart-items-form');
                var href = $form.attr('action');

                var params = $form.serializeArray();
                params.push({ name: 'update_cart', value: 1 });

                element.preventDefault();

                $.ajax({
                    url: href,
                    data: params,
                    success: $.proxy(function (result) {
                        if (result.output) {
                            var cartTitle = $(result.output).find('.c-cart-title');
                            if (cartTitle) {
                                $('.c-checkout').find('.c-cart-title').replaceWith(cartTitle);
                            }

                            var cartItems = $(result.output).find('table.c-cart-items');
                            if (cartItems) {
                                $form.find('table.c-cart-items').replaceWith(cartItems);
                            }

                            var cartTotals = $(result.output).find('table.c-cart-totals');
                            if (cartTotals) {
                                $('.c-cart-wrapper').find('table.c-cart-totals').replaceWith(cartTotals);
                            }
                        }

                        $form.parents('.c-cart-wrapper').removeClass('cart-loading');
                    }, this)
                });

                return false;
            },

            onChangeCartComment: function (element) {
                var value = $(element.currentTarget).val();

                $('#comment').val(value);
            },

            /**
             * When a field has a [data-validate] attribute it runs through this method,
             * and adds or removes .is-valid class based on validation.
             */
            onCheckoutValidateField: function (element) {
                var value = $(element.currentTarget).val();
                var rules = $(element.currentTarget).attr('data-validate');

                if (this.fieldIsValid(value, rules)) {
                    $(element.currentTarget).addClass('is-valid');
                } else {
                    $(element.currentTarget).removeClass('is-valid');
                }
            },

            /**
             *
             *  A checkbox that toggles the visibility of the other billing address fields
             *
             */
            onTogglePickupOrder: function (element) {
                var parent = $(element.currentTarget).parent().parent();
                var checked = $(element.currentTarget).is(':checked');

                parent.children().each(function (index, childElement) {
                    if ($(childElement).hasClass('c-billing-pickup')) {
                        return;
                    }

                    if ($(childElement).hasClass('c-billing-address-wrapper') || $(childElement).hasClass('c-shipping-address-wrapper')) {
                        if (checked) {
                            $(childElement).hide();
                            $('input#shipping-address-billing').attr('checked', true);
                        } else {
                            $(childElement).show();
                        }
                    }
                });

                this.$orderPickupEnabled = !this.$orderPickupEnabled;
            },


            /**
             * Validate a value against a set of rules.
             * Multiple rules are separated with pipe (|).
             * Example rules: 'required|email|same:other_field'
             */
            fieldIsValid: function (value, rules) {
                var valid = true;

                var allRules = rules.split('|');

                for (var i = 0; i < allRules.length; i++) {
                    var params = allRules[i].split(':');
                    var rule = params[0];

                    switch (rule) {
                    case 'required':
                        valid = value;

                        break;
                    case 'email':
                        var regex = /\S+@\S+\.\S+/;
                        valid = regex.test(value);

                        break;
                    case 'same':
                        if (params[1]) {
                            var matchValue = $('[name="' + params[1] + '"]').val();
                            valid = value === matchValue;
                        }

                        break;
                    default:
                        valid = true;
                        break;
                    }

                    if (!valid) {
                        return false;
                    }
                }

                return true;
            },

            onChangeProductId: function (element) {
                var value = $(element.currentTarget).find('option:selected').text();
                $('[data-product-color]').html(value);
            },

            toggleFaqItem: function (element) {
                // console.log($(element.currentTarget));
                $(element.currentTarget).siblings('.answer').slideToggle();
                $(element.currentTarget).parent('.faq-item').toggleClass('active');
            },

            onToggleShowForm: function (event) {
                event.preventDefault();
                console.log('test');
                let parent = $(event.currentTarget).parent();
                if (parent) {
                    $(event.currentTarget).hide();
                }
                
                let targetDiv = $('.activecampaignform');

                if (targetDiv.length) {
                    targetDiv.toggleClass('active');
                }
            },

            toggleBillingCustomEmail: function () {
                $('.address-billing-custom-email').toggleClass('show');
            },

            /**
             * Init call.
             */
            init: function () {
                this.initLightCase();
                this.initLightCaseApim();

                this.initSlider();
                this.initSliderUbr();
                this.initSliderProducts();
                this.initSliderArticles();
                this.initSliderProductDetail();

                this.initDatePickers();

                this.detectWindowScroll();

                this.initResponsiveTables();
                this.initResponsiveEmbedVideos();
                this.initMailSharePopup();
                this.initToggleBlocks();
                this.initMSearch2();
                this.displayStates();
                this.initPostcodeApi();
                this.updateCartCount();
                this.updateHeaderCart();

                this.toggleCompareButton();

                this.lazyLoadIframes();
                    
                $('[data-filler]').trigger('change');
            }
        };

        $(document).on({
            click: $.proxy(Site, 'onClickSearchPlaceholder')
        }, '.form-search .placeholder');

        $(document).on({
            click: $.proxy(Site, 'onToggleOrderDetails')
        }, '.account-order__content');

        $(document).on({
            click: $.proxy(Site, 'onToggleOrderDetailsButton')
        }, '.account-order [data-orders-view-btn]');

        $(document).on({
            click: $.proxy(Site, 'onToggleSearchForm')
        }, '.search-toggle');

        $(document).on({
            submit: $.proxy(Site, 'onSubmitSearchForm')
        }, '.form-search');

        $(document).on({
            click: $.proxy(Site, 'onToggleNavigation')
        }, '.nav-toggle');

        $(document).on({
            click: $.proxy(Site, 'onToggleSubNavigation')
        }, '.has-subnav > a');

        $(document).on({
            click: $.proxy(Site, 'onCloseSubNavigation')
        }, '.close-subnav');

        $(document).on({
            click: $.proxy(Site, 'displayArticleModal')
        }, '[data-article-button]');

        $(document).on({
            click: $.proxy(Site, 'onCloseNavigation')
        }, '.close-nav, .nav-overlay');

        $(document).on({
            click: $.proxy(Site, 'onClickScrollToTop')
        }, '.btn--to-top');

        $(document).on({
            click: $.proxy(Site, 'onClickHash')
        }, 'a[href*="#"]:not([data-rel="lightcase"])');

        $(document).on({
            click: $.proxy(Site, 'openToggleContact')
        }, '[data-contact]');

        $(document).on({
            click: $.proxy(Site, 'openToggleContactForm')
        }, '[data-contact-form]');

        $(document).on({
            click: $.proxy(Site, 'toggleTooltip')
        }, '.btn--tooltip');

        $(document).on({
            click: $.proxy(Site, 'onToggleSocialShare')
        }, '.social-share .social-share--toggle, .social-share .social-share--close');

        $(document).on({
            click: $.proxy(Site, 'onCopyToClipboard')
        }, '.social-share--url input');

        $(document).on({
            click: $.proxy(Site, 'triggerSearchBox')
        }, 'header .search-toggle-dt');

        $(document).on({
            keyup: $.proxy(Site, 'listSearchSuggestions')
        }, 'header .form-search input[type="text"]');

        $(document).on({
            click: $.proxy(Site, 'handleSearchSuggestClick')
        }, '[data-suggestion]');

        $(document).on({
            change: $.proxy(Site, 'displayStates')
        }, '[data-toggle-state]');

        $(document).on({
            click: $.proxy(Site, 'checkoutRequestOffer')
        }, '[data-request-offer]');

        $(document).on({
            change: $.proxy(Site, 'handleProductVariantSelect')
        }, '[data-productvariant-select]');

        $(document).on({
            click: $.proxy(Site, 'toggleReadmoreLinks')
        }, '.link--toggle');

        $(document).on({
            click: $.proxy(Site, 'onToggleChat')
        }, '[data-chat]');

        $(document).on({
            click: $.proxy(Site, 'addCompareProduct')
        }, '[data-compare]');

        $(document).on({
            click: $.proxy(Site, 'removeCompareProduct')
        }, '[data-compare-product-remove]');

        $(document).on({
            submit: $.proxy(Site, 'onAddProductToCart')
        }, 'form.form-product');

        $(document).on({
            submit: $.proxy(Site, 'onAddProductToCart')
        }, 'form.form-product-addtocart');

        $(document).on({
            submit: $.proxy(Site, 'onAddProductToCart')
        }, 'form.form-compare-add-to-cart');

        $(document).on({
            click: $.proxy(Site, 'onAddProductToCart')
        }, 'form.form-order-now');

        $(document).on({
            click: $.proxy(Site, 'onTogglePickupOrder')
        }, '.c-shipping-pickup-checkbox');

        $(document).on({
            change: $.proxy(Site, 'onChangeAddressType')
        }, '[data-address-type]');

        $(document).on({
            change: $.proxy(Site, 'onChangeShippingType')
        }, '.c-shipping-method-radio');

        $(document).on({
            change: $.proxy(Site, 'onChangeCheckoutSelectExistingAddress')
        }, '[data-checkout-existing-address]');

        $(document).on({
            change: $.proxy(Site, 'onChangeCheckoutUseAddressDetailsCheckbox')
        }, '[data-checkout-existing-address-details]');

        $(document).on({
            keyup: $.proxy(Site, 'keyUpVatRegistration')
        }, '[data-vat-number]');

        $(document).on({
            keyup: $.proxy(Site, 'keyUpPhoneNumber'),
            paste: $.proxy(Site, 'keyUpPhoneNumber')
        }, '[data-phone-number]');

        $(document).on({
            change: $.proxy(Site, 'onHandleFilterChange')
        }, '.product-filter');

        $(document).on({
            change: $.proxy(Site, 'onChangeCartItemQuantity')
        }, '[data-cart-item-quantity]');

        $(document).on({
            change: $.proxy(Site, 'toggleExtraOptions')
        }, '[data-filler]');

        $(document).on({
            keyup: $.proxy(Site, 'onChangeCartComment')
        }, '[data-cart-comment]');

        $(document).on({
            keyup: $.proxy(Site, 'onCheckoutValidateField'),
            change: $.proxy(Site, 'onCheckoutValidateField')
        }, '[data-validate]');

        $(document).on({
            change: $.proxy(Site, 'onChangeProductId')
        }, '#product_id');

        $(document).on({
            click: $.proxy(Site, 'toggleOverlay')
        }, '.c-submit button');

        $(document).on({
            click: $.proxy(Site, 'toggleFaqItem')
        }, '.faq-item .question');

        $(document).on({
            click: $.proxy(Site, 'toggleBillingCustomEmail')
        }, '#address-billing-custom-email-toggle');

        $(document).on({
            click: $.proxy(Site, 'onToggleShowForm')
        }, '[title="show-form"]');

        $(document).on({
            click: $.proxy(Site, 'resetFilters')
        }, '[type="reset"]');

        window.onload = function () {
            Site.init();
        };

        window.onresize = function () {
            Site.initSliderUbr();
        };
    }(jQuery)
);